import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import Table from "../../../component/atoms/layout/table/table";
import Td from "../../../component/atoms/layout/table/td";
import Th from "../../../component/atoms/layout/table/th";
import Tr from "../../../component/atoms/layout/table/tr";
import TableText from "../../../component/atoms/text/table/tableText";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import SearchBar from "./../../../component/atoms/input/searchBar";
import EventBtn from "./../../../component/atoms/button/eventBtn";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import RedBtn from "./../../../component/atoms/button/redBtn";
import BlueBtn from "./../../../component/atoms/button/blueBtn";
import Checkbox from "./../../../component/atoms/input/checkbox";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableFilter from "./../../../component/atoms/layout/table/tableFilter";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import SubSideBar from "../../../component/organisms/subSideBar";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import Pagination from "./../../../component/molecules/pagination";
import TableCount from "./../../../component/molecules/tableCount";
import Modal from "./../../../component/templates/Modal";
import scrollToTop from "../../../util/scrollToTop";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import { formatNumberWithCommas } from "./../../../util/formatNumber";
import { route } from "../../../router/route";
import TicketPromotionApi from "../../../api/ticketPromotion.api";
import Empty from "../../../component/molecules/empty";

// sessionStorage 초기화
function sessionStorageInit() {
  sessionStorage.removeItem("sCheckedListStorage");
  const event = new Event("sessionStorageChange");
  window.dispatchEvent(event);
}

const ShoppingMembershipProduct = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars

  const [keyword, setKeyword] = useState("");
  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  // ---------- 쓰기 권한체크 ---------- //
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.shopping_membership_product)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("sCheckedListStorage");
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");

    getProductList();
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  const [productList, setProductList] = useState([]);

  const getProductList = async () => {
    try {
      const data = {
        page: Number(page),
        size: Number(pagination.size),
      };

      if (keyword) {
        data.keyword = searchParams.get("keyword");
      }

      const response = (await TicketPromotionApi.getList(data)).data.data;

      const processedResponse = [...response.content].map((item, index) => {
        return {
          ...item,
          numbering: response.totalCount - (page - 1) * pagination.size - index,
        };
      });

      setProductList(processedResponse);
      setPagination({
        ...pagination,
        totalCount: response.totalCount,
        totalPages: Math.ceil(response.totalCount / 10),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const sessionStorageCheckedList = sessionStorage.getItem(
    "sCheckedListStorage"
  );
  const [checkedListStorage, setCheckedListStorage] = useState([]);
  const [buttonGroupOpen, setButtonGroupOpen] = useState(false);
  const [isAllCheck, setIsAllCheck] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setCheckedListStorage(
        sessionStorageCheckedList ? JSON.parse(sessionStorageCheckedList) : []
      );
    };

    window.addEventListener("sessionStorageChange", handleStorageChange);

    return () => {
      window.removeEventListener("sessionStorageChange", handleStorageChange);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    sessionStorage.setItem(
      "sCheckedListStorage",
      JSON.stringify(checkedListStorage)
    );
  }, [page]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (productList.length > 0) {
      const idsInArray1 = new Set(checkedListStorage.map((item) => item.id));

      const allIdsIncluded = productList.every((item) =>
        idsInArray1.has(item.id)
      );

      setIsAllCheck(allIdsIncluded);
    }

    if (checkedListStorage.length > 0) {
      setButtonGroupOpen(true);
    } else {
      setButtonGroupOpen(false);
    }
  }, [checkedListStorage, productList]); // eslint-disable-line react-hooks/exhaustive-deps

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteHandler = async () => {
    try {
      let delIds = checkedListStorage.map((item) => item.id);

      const data = {
        ids: delIds,
        allFlag: false,
      };

      await TicketPromotionApi.delete(data);

      sessionStorageInit();
      setDeleteModalOpen(false);
      toast(toastMsg.delete);

      navigate(
        `${route.shopping_membership_product}?page=1&keyword=${keyword}`
      );
    } catch (error) {
      errorHandler(error);
    }
  };

  const replicationHandler = async () => {
    try {
      for (let i = 0; i < checkedListStorage.length; i++) {
        const data = checkedListStorage[i];
        await TicketPromotionApi.create(data);
      }

      sessionStorageInit();
      toast(toastMsg.create);
      getProductList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 판매 상태 관련 ---------- //
  const [filterOpen, setFilterOpen] = useState(-1);

  const activationChangeFunc = async (id, value) => {
    try {
      const data = {
        activation: value,
      };

      await TicketPromotionApi.updateActivation(id, data);

      sessionStorageInit();
      toast(toastMsg.update);
      getProductList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 카테고리 영역 */}
        <SubSideBar title="카테고리">
          <SubSideBarItem
            selected={true}
            onClick={() => {
              navigate(route.shopping_membership_product);
            }}
          >
            수강권
          </SubSideBarItem>
          <SubSideBarItem
            selected={false}
            onClick={() => {
              navigate(route.shopping_membership_product_lms);
            }}
          >
            멤버십 상품 전자책
          </SubSideBarItem>
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>멤버십 상품관리</TableTitle>
          {/* 테이블 상단 영역 */}
          <TableTop>
            <TableCount text={"수강권"} count={""} />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <SearchBar
                value={keyword}
                placeholder={"프로모션명"}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    sessionStorageInit();
                    navigate(
                      `${route.shopping_membership_product}?page=1&keyword=${keyword}`
                    );
                  }
                }}
                onClick={() => {
                  sessionStorageInit();
                  navigate(
                    `${route.shopping_membership_product}?page=1&keyword=${keyword}`
                  );
                }}
              />
              {/* <ExcelBtn /> */}
              <EventBtn
                text={"상품 추가하기"}
                onClick={() => {
                  if (!isWriteAuthority) {
                    toast(
                      <>
                        편집 권한이 없습니다.
                        <br />
                        최고관리자에게 문의하세요.
                      </>
                    );
                    return;
                  }
                  navigate(route.shopping_membership_product_create);
                  scrollToTop();
                }}
              />
            </div>
          </TableTop>

          {/* 버튼 그룹 */}
          {buttonGroupOpen && isWriteAuthority && (
            <div
              style={{
                width: "100%",
                height: 49,
                display: "flex",
                gap: 12,
              }}
            >
              <RedBtn
                onClick={() => {
                  setDeleteModalOpen(true);
                }}
              >
                삭제
              </RedBtn>
              <BlueBtn
                onClick={() => {
                  replicationHandler();
                }}
              >
                복제
              </BlueBtn>
            </div>
          )}

          {/* 테이블 영역 */}
          <Table>
            <colgroup>
              {/* 합계: 1044px */}
              {/* 체크박스 */}
              <col width="56px" />
              {/* No */}
              <col width="48px" />
              {/* 프로모션명 */}
              <col width="342px" />
              {/* 월간 수강권 가격 */}
              <col width="119px" />
              {/* 1년 수강권 가격 */}
              <col width="136px" />
              {/* 상태 */}
              <col width="125x" />
              {/* 판매시작일 */}
              <col width="113px" />
              {/* 판매중단일 */}
              <col width="105px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "41px", background: "#272829" }}>
                <Th style={{ paddingLeft: "16px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // 배열 병합 및 중복 제거
                        const mergedArray = [
                          ...productList,
                          ...checkedListStorage,
                        ].reduce((acc, current) => {
                          const existingItem = acc.find(
                            (item) => item.id === current.id
                          );
                          if (!existingItem) {
                            acc.push(current);
                          }
                          return acc;
                        }, []);

                        setCheckedListStorage(mergedArray);
                      } else {
                        const idsToExclude = new Set(
                          productList.map((item) => item.id)
                        );
                        const filteredArray = checkedListStorage.filter(
                          (item) => !idsToExclude.has(item.id)
                        );

                        setCheckedListStorage(filteredArray);
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    No
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    프로모션명
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                      textAlign: "right",
                      paddingRight: 32,
                    }}
                  >
                    월간 수강권 가격
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                      textAlign: "right",
                      paddingRight: 44,
                    }}
                  >
                    1년 수강권 가격
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    상태
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    판매시작일
                  </TableText>
                </Th>
                <Th>
                  <TableText
                    style={{
                      fontWeight: "600",
                      lineHeight: "22.75px",
                    }}
                  >
                    판매중단일
                  </TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {productList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{
                      height: "59px",
                      background: "transparent",
                      borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
                    }}
                  >
                    <Td style={{ paddingLeft: "16px" }}>
                      <Checkbox
                        checked={checkedListStorage.some(
                          (item02) => item02.id === item.id
                        )}
                        onChange={() => {
                          if (
                            checkedListStorage.length > 0 &&
                            checkedListStorage.some(
                              (item02) => item02.id === item.id
                            )
                          ) {
                            let temp = checkedListStorage.filter(
                              (item02) => item02.id !== item.id
                            );
                            setCheckedListStorage(temp);
                          } else {
                            setCheckedListStorage([
                              item,
                              ...checkedListStorage,
                            ]);
                          }
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText>{item.numbering}</TableText>
                    </Td>
                    <Td>
                      <TableText
                        onClick={() => {
                          if (!isWriteAuthority) {
                            toast(
                              <>
                                편집 권한이 없습니다.
                                <br />
                                최고관리자에게 문의하세요.
                              </>
                            );
                            return;
                          }

                          navigate(
                            `${route.shopping_membership_product_edit}/${item.id}`
                          );
                        }}
                        style={{
                          maxWidth: "265px",
                          marginRight: "6px",
                          cursor: "pointer",
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "Pretendard",
                            fontWeight: 500,
                            fontSize: "15px",
                            lineHeight: "17.9px",
                            color: "#009bde",
                          }}
                        >
                          {item.accentTitle}{" "}
                        </span>
                        {item.title}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          textAlign: "right",
                          paddingRight: 32,
                        }}
                      >
                        {formatNumberWithCommas(item.monthTicket.price)}원
                      </TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{
                          textAlign: "right",
                          paddingRight: 44,
                        }}
                      >
                        {formatNumberWithCommas(item.annualTicket.price)}원
                      </TableText>
                    </Td>
                    <Td>
                      <TableFilter
                        style={{
                          width: "fit-content",
                          gap: 10,
                        }}
                        onClick={() => {
                          if (!isWriteAuthority) {
                            toast(
                              <>
                                편집 권한이 없습니다.
                                <br />
                                최고관리자에게 문의하세요.
                              </>
                            );
                            return;
                          }

                          filterOpen === index
                            ? setFilterOpen(-1)
                            : setFilterOpen(index);
                        }}
                        isOpen={filterOpen === index}
                        selectedValue={item.activation}
                        list={[
                          {
                            value: true,
                            title: "판매중",
                            onClick: () => {
                              if (item.endDate) {
                                if (moment(item.endDate).isBefore(moment())) {
                                  return toast("판매중단일이 지났습니다.");
                                }
                              }
                              activationChangeFunc(item.id, true);
                              setFilterOpen(-1);
                            },
                          },
                          {
                            value: false,
                            title: "판매중단",
                            onClick: () => {
                              activationChangeFunc(item.id, false);
                              setFilterOpen(-1);
                            },
                          },
                        ]}
                      />
                    </Td>
                    <Td>
                      <TableText>
                        {!item.startDate
                          ? moment(item.createdAt).format("YYYY-MM-DD")
                          : moment(item.startDate).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {!item.endDate ||
                        moment(item.endDate).format("YYYY-MM-DD") ===
                          "9999-12-31"
                          ? "-"
                          : moment(item.endDate).format("YYYY-MM-DD")}
                      </TableText>
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          {productList.length > 0 ? null : <Empty />}

          {/* 페이지네이션 영역 */}
          <Pagination
            route={route.shopping_membership_product}
            queryString={`keyword=${keyword}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
            first={pagination.first}
            last={pagination.last}
          />
        </DetailPageLayout>
      </MainLayout>

      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteHandler}
        />
      )}
    </>
  );
};

export default ShoppingMembershipProduct;
